import { render, staticRenderFns } from "./NovaUnidade.vue?vue&type=template&id=78bd35e0"
import script from "./NovaUnidade.vue?vue&type=script&lang=js"
export * from "./NovaUnidade.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports